import { render, staticRenderFns } from "./SendWithTextMessage.vue?vue&type=template&id=01076f2c&scoped=true"
import script from "./SendWithTextMessage.vue?vue&type=script&lang=js"
export * from "./SendWithTextMessage.vue?vue&type=script&lang=js"
import style0 from "./SendWithTextMessage.vue?vue&type=style&index=0&id=01076f2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01076f2c",
  null
  
)

export default component.exports